import React, { useState, useRef, useEffect } from 'react';
import styles from './NewTravelSection.module.css';

// Assets from src/assets/pic/채팅방
import iconKakao from '../../../assets/pic/채팅방/카카오톡.png';
import iconLink from '../../../assets/pic/채팅방/링크초대.png';
import iconID from '../../../assets/pic/채팅방/ID로추가.png';
import iconCamera from '../../../assets/pic/채팅방/사진선택.png';

import UserSearchModal from './UserSearchModal';
import ImageCropModal from '../../../components/ImageCropper/ImageCropModal'; // Import Cropper

const RoomCreationStep = ({
    roomName,
    setRoomName,
    onBack,
    onStartChat,
    roomFile,
    setRoomFile,
    ...props
}) => {
    const [previewUrl, setPreviewUrl] = useState(null);
    const [showIdModal, setShowIdModal] = useState(false);
    const [pendingFileSrc, setPendingFileSrc] = useState(null); // For cropper
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (roomFile) {
            const url = URL.createObjectURL(roomFile);
            setPreviewUrl(url);
            return () => URL.revokeObjectURL(url);
        } else {
            setPreviewUrl(null);
        }
    }, [roomFile]);

    const handleImageUpload = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            // Instead of setting directly, open cropper
            const url = URL.createObjectURL(file);
            setPendingFileSrc(url);
            // Reset input so same file can be selected again if needed
            e.target.value = null;
        }
    };

    const handleCropConfirm = (croppedBlob) => {
        // Wrap Blob into a File with a filename for better backend compatibility
        const fileType = croppedBlob?.type || 'image/jpeg';
        const extension = fileType === 'image/png' ? 'png' : 'jpg';
        const croppedFile = new File([croppedBlob], `room-image.${extension}`,
            { type: fileType }
        );
        setRoomFile(croppedFile);
        setPendingFileSrc(null); // Close modal
    };

    const handleCropCancel = () => {
        setPendingFileSrc(null); // Close modal
    };

    return (
        <>
            <div className={styles.creationCard}>
                {/* Profile Image Uploader */}
                <div className={styles.profileUploader} onClick={handleImageUpload}>
                    <div className={styles.imagePlaceholder}>
                        {previewUrl ? (
                            <img src={previewUrl} alt="Room" className={styles.uploadedImage} />
                        ) : (
                            <div className={styles.defaultImageBg} />
                        )}
                    </div>
                    {/* Camera Badge - Using the PNG asset */}
                    <img src={iconCamera} alt="Upload" className={styles.cameraBadgeIcon} />
                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        accept="image/*"
                        onChange={handleFileChange}
                    />
                </div>

                {/* Name Input */}
                <div className={styles.inputContainer}>
                    <input
                        type="text"
                        className={styles.roomNameInput}
                        placeholder="채팅방 이름"
                        value={roomName}
                        onChange={(e) => setRoomName(e.target.value)}
                        maxLength={20}
                    />
                    <span className={styles.charCount}>{roomName.length}/20</span>
                </div>

                <p className={styles.inviteText}>친구/가족들과 함께하는 그룹 채팅방을 만들어보세요.</p>

                {/* Invite Buttons Grid */}
                <div className={styles.inviteGrid}>
                    <button className={styles.inviteButton}>
                        <div className={styles.btnContent}>
                            <img src={iconKakao} alt="Kakao" className={styles.btnIcon} />
                            <span>카톡으로 초대</span>
                        </div>
                    </button>
                    <button
                        className={styles.inviteButton}
                        onClick={() => alert("채팅방 생성 후 초대 링크를 공유할 수 있습니다.")}
                    >
                        <div className={styles.btnContent}>
                            <img src={iconLink} alt="Link" className={styles.btnIcon} />
                            <span>링크로 초대</span>
                        </div>
                    </button>
                    <button
                        className={styles.inviteButton}
                        onClick={() => setShowIdModal(true)}
                    >
                        <div className={styles.btnContent}>
                            <img src={iconID} alt="ID" className={styles.btnIcon} />
                            <span>ID로 추가</span>
                        </div>
                    </button>
                </div>
            </div>

            {/* Bottom Navigation */}
            <div className={styles.bottomNav}>
                <button className={styles.backButton} onClick={onBack}>
                    이전
                </button>
                <button
                    className={`${styles.startButton} ${roomName.length > 0 ? styles.startButtonActive : ''}`}
                    disabled={roomName.length === 0}
                    onClick={onStartChat}
                >
                    채팅 시작하기
                </button>
            </div>

            {/* ID Search Modal Overlay */}
            {showIdModal && (
                <UserSearchModal
                    onClose={() => setShowIdModal(false)}
                    onConfirm={(id) => {
                        if (props.onAddMember) {
                            props.onAddMember(id);
                        } else {
                            console.warn("onAddMember prop missing");
                        }
                        setShowIdModal(false);
                    }}
                />
            )}

            {/* Image Cropper Modal */}
            {pendingFileSrc && (
                <ImageCropModal
                    imageSrc={pendingFileSrc}
                    onConfirm={handleCropConfirm}
                    onCancel={handleCropCancel}
                />
            )}
        </>
    );
};

export default RoomCreationStep;
